import request from '@/utils/requestLongTime'
import requestNoToken from '@/utils/requestNoToken'
import Qs from 'qs'
export function selectListByType(query) {
  return requestNoToken({
    url: '/index/goodsListByType',
    method: 'get',
    params: query
  })
}
export function selectList(query) {
  return requestNoToken({
    url: '/index/goodsList',
    method: 'get',
    params: query
  })
}

export function selectListByName(query) {
  return requestNoToken({
    url: '/index/goodsListByName',
    method: 'get',
    params: query
  })
}

export function selectListByNameAndUserId(query) {
  return request({
    url: '/index/goodsListByNameAndUserId',
    method: 'get',
    params: query
  })
}

export function addOrUpdateWish(query) {
  return request({
    url: '/wish/addOrUpdateWish',
    method: 'get',
    params: query
  })
}

export function addBagByWish(query) {
  return request({
    url: '/wish/addBagByWish',
    method: 'get',
    params: query
  })
}

export function guessYourLove(query) {
  return request({
    url: '/index/guessYourLove',
    method: 'get',
    params: query
  })
}



// WEBPACK FOOTER //
// ./src/api/watchList.js